// @vue/components
export const Offer = {
  methods: {
    hideIconRight (value) {
      if (value === 0 || value) return "close-circle";
    }
  }
};